var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslate } from 'react-admin';
import { useFormState } from 'react-hook-form';
import { Button } from '@mui/material';
import { useWizardFormContext } from './useWizardFormContext';
export var PreviousButton = function (_a) {
    var disabled = _a.disabled, rest = __rest(_a, ["disabled"]);
    var translate = useTranslate();
    var isValidating = useFormState().isValidating;
    var _b = useWizardFormContext(), hasPreviousStep = _b.hasPreviousStep, goToPreviousStep = _b.goToPreviousStep;
    if (!goToPreviousStep) {
        throw new Error('The NextButton component cannot be used outside a WizardFormContext');
    }
    var label = translate('ra-form-layout.action.previous');
    var handleClick = function (event) {
        event.preventDefault();
        goToPreviousStep();
    };
    if (!hasPreviousStep)
        return null;
    return (_jsx(Button, __assign({ color: "primary", disabled: disabled || isValidating, type: "button", "aria-label": label, onClick: handleClick }, rest, { children: label })));
};
